import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { apiCall } from "services/api";
import { paramParsify } from "utils/queryParams";

export const useGetReportList = ({ id } = {}) => {
  const location = useLocation();
  const queryParams = paramParsify(location?.search);

  const [response, setResponse] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(
    async ({ id: passedId } = {}) => {
      setLoading(true);
      try {
        const response = await apiCall({
          url: `/v1/company/${passedId || id}/reports`,
          queryParams,
          method: "GET",
        });
        setResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    },
    [id, queryParams],
  );

  useEffect(() => {
    if (id) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams?.year, id]);

  return { response, loading, error, refetch: fetchData };
};
